(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["904-drop-products"] && !Shopify.designMode) return;
  try {
    const url=new URL(window.location.href);if(url.hash){document.addEventListener('DOMContentLoaded',()=>{const card=document.getElementById(url.hash.slice(1));if(card)card.scrollIntoView({behavior:'instant'});},{once:true});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["904-event-board"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('event-archive-904')) {
    customElements.define('event-archive-904', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.dataset.archiveInitialized === 'true') return;
        this.track = this.querySelector('[data-archive-track]');
        this.previousButton = this.querySelector('[data-archive-direction="previous"]');
        this.nextButton = this.querySelector('[data-archive-direction="next"]');
        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.handleScroll = () => this.updateControls();
        this.handlePrevious = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.previousButton.addEventListener('click', this.handlePrevious);
        this.nextButton.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(this.handleScroll);
        this.resizeObserver.observe(this.track);
        this.dataset.archiveInitialized = 'true';
        this.updateControls();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.resizeObserver?.disconnect();
        delete this.dataset.archiveInitialized;
      }

      move(direction) {
        const card = this.track.querySelector('.event-board-904__archive-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      updateControls() {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.previousButton.disabled = this.track.scrollLeft <= 1;
        this.nextButton.disabled = this.track.scrollLeft >= maximum - 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
